"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Place = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.Place = {
  name: 'Place',
  label: 'Location',
  autoRoutes: ['list', 'create', 'update'],
  usePlatformActivity: true,
  useSlices: true,
  table: {
    fieldNames: ["info", "regions", "latitude", "longitude"]
  },
  list: {
    banner: {
      content: 'Created specific named addresses and locations.'
    },
    resultsVariant: 'table'
  },
  form: {
    paginate: true,
    fieldSets: [{
      name: 'overview'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      banner: {
        type: 'linked',
        entityTypeName: 'Banner'
      },
      regions: {
        type: 'linkedMultiple',
        entityTypeName: 'Region',
        description: 'Which {{REGIONS}} is this {{PLACE}} located in?'
      },
      latitude: {
        type: 'float',
        maxWidth: '400px',
        description: 'What is the Latitude of this {{PLACE}}, in decimal degrees notation?'
      },
      longitude: {
        type: 'float',
        maxWidth: '400px',
        description: 'What is the Longitude of this {{PLACE}}, in decimal degrees notation?'
      },
      address1: {
        type: 'text',
        recommended: false
      },
      address2: {
        type: 'text',
        recommended: false
      },
      city: {
        type: 'linked',
        entityTypeName: 'Location'
      }
    })
  }
};